const createStepPath = '/listing/create/:listingId/location'
const detailsStepPth = '/listing/create/:listingId/details'
const mediaStepPath = '/listing/create/:listingId/media'
const summaryStepPath = '/listing/create/:listingId/summary'

export const FORM_STEPS = {
  'create-listing': {
    path: createStepPath,
    backPath: '/listings',
    stepNumber: 1
  },
  'listing-details': {
    path: detailsStepPth,
    backPath: createStepPath,
    stepNumber: 2
  },
  'listing-media': { path: mediaStepPath, backPath: detailsStepPth, stepNumber: 3 },
  'listing-summary': { path: summaryStepPath, backPath: mediaStepPath, stepNumber: 4 }
} as const
